import React, { FC } from 'react';
import { connect } from 'react-redux';
import {
	fetchLocationsWithRegionsAndSubRegionsForBuyer,
	fetchLocationsWithRegionsAndSubRegionsForSupplier,
} from '../../thunks/locations_thunks';
import LocationsTreeSelect from '../locations_tree_select/LocationsTreeSelect';
import { LocationDropdownRecord } from '../name_component/location/LocationDropdownRecord';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { withRouter } from 'react-router';

const BuyerRegionsLocationsTreeSelect: FC<any> = ({
	onChange,
	mode,
	targetCollectionName,
	filtersValueAccessor,
	filtersSlice,
	locations,
	disabled,
	fetchLocationsWithHierarchy,
	noIsActiveFilter = false,
	hiddenRecords,
	style = {},
	value,
}) => {
	return (
		<div style={{ ...style }}>
			<LocationsTreeSelect
				allowClear={true}
				style={{ width: '100%' }}
				stateSlice={locations}
				targetCollectionName={targetCollectionName}
				value={filtersValueAccessor ? filtersValueAccessor(filtersSlice) : value}
				onChange={onChange}
				disabled={disabled}
				hiddenRecords={hiddenRecords}
				fetchData={(
					searchText,
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				) => {
					return fetchLocationsWithHierarchy(
						{ name: searchText, noIsActiveFilter },
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
					);
				}}
				fetchMultiple={() => {}}
				renderRecord={(record) => <LocationDropdownRecord record={record} />}
				sortBy={{ sort_by: 'name', order: 'ascend' }}
				mode={mode}
			/>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,

	filtersSlice: ownProps.filtersSlice,
	regions: state.regions,
	locations: state.locations,
	workOrders: state.work_orders,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	fetchLocationsWithHierarchy: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? fetchLocationsWithRegionsAndSubRegionsForSupplier(
						{ ...params, noIsActiveFilter: true },
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
				: fetchLocationsWithRegionsAndSubRegionsForBuyer(
						{ ...params, noIsActiveFilter: true },
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
		),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(BuyerRegionsLocationsTreeSelect)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
